import { useCallback, useEffect, useState } from "react";
import { CalendarDays, Check, Send, X } from "lucide-react";
import { api, ApiError } from "../lib/api";

type LeaveItem = { id: string; leave_type: string; start_date: string; end_date: string; days: number; reason: string; status: "pending" | "approved" | "rejected" };

export function EmployeeLeave() {
  const today = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Bangkok", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
  const [items, setItems] = useState<LeaveItem[]>([]);
  const [leaveType, setLeaveType] = useState("ลาป่วย");
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [reason, setReason] = useState("");
  const [notice, setNotice] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const load = useCallback(() => api<{ items: LeaveItem[] }>("/api/leaves").then((result) => setItems(result.items)), []);
  useEffect(() => { void load(); }, [load]);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSaving(true); setNotice(null);
    try {
      await api("/api/leaves", { method: "POST", body: JSON.stringify({ leaveType, startDate, endDate, reason }) });
      setReason("");
      setNotice("ส่งคำขอลาให้ผู้จัดการแล้ว");
      await load();
    } catch (error) {
      setNotice(error instanceof ApiError ? error.message : "ส่งคำขอไม่สำเร็จ");
    } finally { setSaving(false); }
  };

  return (
    <main className="employee-page employee-leave-page" id="main-content">
      <header className="employee-header"><div><p className="welcome">ขอลาออนไลน์</p><h1>ส่งคำขอลา</h1></div><span className="avatar-fallback"><CalendarDays size={21} /></span></header>
      <form className="employee-leave-form" onSubmit={submit}>
        <label>ประเภทการลา<select value={leaveType} onChange={(event) => setLeaveType(event.target.value)}><option>ลาป่วย</option><option>ลากิจ</option><option>ลาพักร้อน</option></select></label>
        <div className="field-row"><label>วันเริ่ม<input type="date" min={today} value={startDate} onChange={(event) => setStartDate(event.target.value)} /></label><label>วันสิ้นสุด<input type="date" min={startDate} value={endDate} onChange={(event) => setEndDate(event.target.value)} /></label></div>
        <label>เหตุผล<textarea value={reason} onChange={(event) => setReason(event.target.value)} maxLength={500} placeholder="ระบุเหตุผลสั้น ๆ" required /></label>
        {notice && <p className="inline-notice" role="status">{notice}</p>}
        <button className="button primary large" disabled={saving || !reason.trim()}><Send size={19} />{saving ? "กำลังส่ง…" : "ส่งคำขอลา"}</button>
      </form>
      <section className="employee-leave-history"><h2>ประวัติคำขอ</h2>{items.length === 0 ? <p className="leave-empty">ยังไม่มีคำขอลา</p> : items.map((item) => <article key={item.id}><span className={`leave-request-icon is-${item.status}`}>{item.status === "approved" ? <Check size={17} /> : item.status === "rejected" ? <X size={17} /> : <CalendarDays size={17} />}</span><div><strong>{item.leave_type} · {item.days} วัน</strong><small>{item.start_date} ถึง {item.end_date}</small><p>{item.reason}</p></div><span className={`leave-status ${item.status}`}>{item.status === "approved" ? "อนุมัติแล้ว" : item.status === "rejected" ? "ไม่อนุมัติ" : "รออนุมัติ"}</span></article>)}</section>
    </main>
  );
}
